import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input,} from 'antd';
import { useBnsJiaoChengUpdateQuery, useBnsJiaoChengUpdateSaveMutation } from '../../store/ReactWebSiteApi';
import MyEditor from '../../cpn/MyEditor';
import WebGoodsTypeSelect from '../goodsType/WebGoodsTypeSelect';
import SonTypeSelect from '../goodsType/SonTypeSelect';
import GetWebGoods from '../goods/GetWebGoods';
import { EditOutlined } from '@ant-design/icons';
function TeachEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bjc_content:''
    }); 
    const {data,isSuccess} = useBnsJiaoChengUpdateQuery({bjc_id:props.bjc_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bjc_name:data.Result.bjc_name,
                    bjc_content:data.Result.bjc_content,
                    bjc_eowg_name:data.Result.bjc_eowg_name,
                    bjc_bg_id:data.Result.bjc_bg_id,
                    bjc_bgn_id:data.Result.bjc_bgn_id,
                    bjc_bg_name:data.Result.bjc_bg_name,
                    bjc_bgn_name:data.Result.bjc_bgn_name,
                })
                setInfo(prevState=>({...prevState,
                    bjc_name:data.Result.bjc_name,                  
                    bjc_content:data.Result.bjc_content,    
                    bjc_eowg_name:data.Result.bjc_eowg_name,
                    bjc_eowg_id:data.Result.bjc_eowg_id,
                    bjc_bg_id:data.Result.bjc_bg_id,
                    bjc_bgn_id:data.Result.bjc_bgn_id,
                    bjc_bg_name:data.Result.bjc_bg_name,
                    bjc_bgn_name:data.Result.bjc_bgn_name,
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsJiaoChengUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}><EditOutlined /> 修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改教程'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bjc_uid" : localStorage.getItem('eu_id'),
                        "bjc_uname" : localStorage.getItem('eu_name'),
                        "bjc_content" : info.bjc_content,
                        "bjc_dept_id" : info.bjc_dept_id,                        
                        "bjc_e_id" : localStorage.getItem('e_id'),
                        "bjc_name" : info.bjc_name,                              
                        "bjc_id" : props.bjc_id,    
                        "bjc_eowg_id" : info.bjc_eowg_id,
                        "bjc_eowg_name" : info.bjc_eowg_name,                           
                        "bjc_bg_id" : info.bjc_bg_id,
                        "bjc_bgn_id" : info.bjc_bgn_id,
                        "bjc_bg_name" : info.bjc_bg_name,
                        "bjc_bgn_name" : info.bjc_bgn_name,
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <WebGoodsTypeSelect
                        label='商品类型'
                        required
                        wrapperCol={{span:10}} 
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bjc_bg_id:e,bjc_bg_name:f}))
                        }}  
                        name='bjc_bg_id'
                    />
                    <SonTypeSelect
                        label='子类型'
                        required
                        wrapperCol={{span:10}} 
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bjc_bgn_id:e,bjc_bgn_name:f}))
                        }}  
                        eowgt_id={info.bjc_bg_id}
                        name='bjc_bgn_name'
                    />
                    <GetWebGoods
                        label='商品'
                        required
                        wrapperCol={{span:10}} 
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bjc_eowg_id:e,bjc_eowg_name:f}))
                        }}  
                        eowgt_id={info.bjc_bg_id}
                        eowgts_id={info.bjc_bgn_id}
                        name='bjc_eowg_name'
                    />                      
                    <Form.Item name="bjc_name" label='名称' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bjc_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item name="bjc_content" label='备注' wrapperCol={{span:20}}>
                        <MyEditor 
                            onChange={(e) => {
                                console.log(e);
                                setInfo(prevState=>({...prevState,bjc_content:e}))
                            }}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default TeachEdit